import { render, staticRenderFns } from "./IntegralRecording.vue?vue&type=template&id=1818fe21&scoped=true&"
import script from "./IntegralRecording.vue?vue&type=script&lang=ts&"
export * from "./IntegralRecording.vue?vue&type=script&lang=ts&"
import style0 from "./IntegralRecording.vue?vue&type=style&index=0&id=1818fe21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818fe21",
  null
  
)

export default component.exports